import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoadingModule } from '../loading/loading.module';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { EventLogDetailDialogComponent } from './event-log-detail-dialog/event-log-detail-dialog.component';
import { EventLogsComponent } from './event-logs/event-logs.component';
import { EventLogsEffects } from './store/event-logs.effects';
import * as fromEventLogs from './store/event-logs.reducers';

// NOTE: not used
// Included in wireframes but not included in final product at the moment

const eventLogsRoutes: Routes = [
    { path: Pages.eventLogs.path, component: EventLogsComponent },
    { path: '**', component: EventLogsComponent }
];

@NgModule({
    declarations: [EventLogsComponent, EventLogDetailDialogComponent],
    imports: [
        CommonModule,
        MaterialModule,
        LoadingModule,
        LocationContextPanelModule,
        NotificationsModule,
        RouterModule.forChild(eventLogsRoutes),
        StoreModule.forFeature(fromEventLogs.eventLogsFeatureKey, fromEventLogs.eventLogsContextReducer, {
            metaReducers: fromEventLogs.metaReducers
        }),
        EffectsModule.forFeature([EventLogsEffects])
    ]
})
export class EventLogsModule {}
